// extracted by mini-css-extract-plugin
export default {"container":"sendEmailViaClient_container__knGu8"};